var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnresolved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-circle-info",
    d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm1,9a1,1,0,0,1-2,0V19a1,1,0,0,1,2,0Zm-1-4a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,18,17Zm-6.92,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0h5V5a3.009,3.009,0,0,0,3,3h5v2a7.989,7.989,0,0,0-6.92,12ZM12,5V.15a3.147,3.147,0,0,1,1.23.73l3.9,3.94a2.864,2.864,0,0,1,.7,1.17H13a1,1,0,0,1-1-1Z",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnresolved);
export default __webpack_public_path__ + "static/media/unresolved.8d66af0ab8630da0189081b09f0ca744.svg";
export { ForwardRef as ReactComponent };